import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { MdKeyboardArrowRight } from 'react-icons/md';

import ROUTES from '../../routes';
import { capitalizeFirstLetter } from '../../utils/formatting';
import Link from '../Link';

import styles from './aside.module.css';

const AsideSqlTemplates = ({ className = '', data }) => {
  const router = useRouter();
  const { id, slug } = router.query;
  const [openSection, setOpenSection] = useState();
  const [sections, setSections] = useState([]);

  useEffect(() => {
    setOpenSection(id);
  }, [id]);

  const formatPost = (postData) => {
    const { post_information, slug: postSlug, id: postId } = postData;
    const post = {
      ...postData,
      ...JSON.parse(post_information),
      slug: postSlug,
      url: postId,
    };
    return post;
  };

  useEffect(() => {
    if (data && id) {
      const newSections = [];
      data.forEach((postData) => {
        const formattedPost = formatPost(postData);
        const sectionIndex = newSections.findIndex(
          (s) => s.id === formattedPost.id,
        );
        if (sectionIndex !== -1) {
          newSections[sectionIndex] = {
            ...newSections[sectionIndex],
            posts: [...newSections[sectionIndex].posts, formattedPost],
          };
        } else {
          newSections.push({
            id: formattedPost.id,
            title: capitalizeFirstLetter(formattedPost.id),
            posts: [formattedPost],
          });
        }
      });
      setSections(newSections);
    }
  }, [id, slug, data]);

  const isSelected = (postSlug) => slug === postSlug || id === postSlug;

  return (
    <aside className={`pl-5 ${className || ''}`}>
      <ol className={styles.tree__container}>
        {sections.map((section) => {
          const isOpen = openSection === section.id;
          return (
            <li
              className={`${styles.tree__item} mb-3`}
              key={`section-${section.id}`}
            >
              <label
                className={`${styles.tree__label} cursor-pointer font-inter transition-colors duration-100 ease-in-out mb-2 flex items-center font-medium py-2`}
                onClick={() => setOpenSection(section.id)}
              >
                <div className="pr-1">
                  <i
                    className={`flex items-center justify-center w-7 h-7 transform text-gray-300 ${
                      isOpen ? 'rotate-90' : ''
                    }`}
                  >
                    <MdKeyboardArrowRight />
                  </i>
                </div>
                <p className="text-sm hover:text-blue-100 text-black leading-snug">
                  {section.title}
                </p>
              </label>
              <ol
                className={styles.ol}
                style={{ '--height': isOpen ? '576px' : '0px' }}
              >
                {section.posts?.map((key, index) => (
                  <li
                    key={`${section.id}-post-${index}`}
                    className="leading-4 mb-2"
                  >
                    <Link
                      href={ROUTES.sqlTemplatesPost().href}
                      asPath={ROUTES.sqlTemplatesPost(key.url, key.slug).asPath}
                    >
                      <a
                        className={`text-black hover:text-blue-100 text-xs font-inter transition-colors duration-100 ease-in-out py-1 block ${
                          isSelected(key.slug) && 'text-blue-100'
                        }`}
                      >
                        {key.title}
                      </a>
                    </Link>
                  </li>
                ))}
              </ol>
            </li>
          );
        })}
      </ol>
    </aside>
  );
};

export default AsideSqlTemplates;
